module.exports = __webpack_public_path__ + "60468db9ef8ce24f66fc43125d65f0d2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-firefighter-s.png
// module id = 2260
// module chunks = 0